if (!customElements.get("slide-show")) {
  class e extends HTMLElement {
    constructor() {
      super();
      let e = this,
        t = "true" === e.dataset.dots,
        i = Array.from(e.querySelectorAll(".carousel__slide")),
        s = "false" != e.dataset.autoplay && parseInt(e.dataset.autoplay, 10),
        a = "center" == e.dataset.align ? "center" : "left",
        l = "true" == e.dataset.fade,
        o = e.querySelector(".flickity-prev"),
        r = e.querySelector(".flickity-next"),
        n = e.querySelector(".flickity-page-dots"),
        hasDots = e.classList.contains("flickity-page-dots"),
        d = e.parentNode.querySelector(".flickity-progress--bar"),
        heroBanner = e.classList.contains("hero-banner-slideshow"),
        slideCount = i.length,
        twoSlideFadeHero = heroBanner && l && slideCount === 2,
        c = [],
        u = "rtl" === document.dir,
        y =
          document.body.classList.contains("animations-true") &&
          "undefined" != typeof gsap,
        h = 0,
        m = {
          wrapAround: !twoSlideFadeHero,
          cellAlign: a,
          pageDots: true && hasDots,
          contain: !0,
          fade: l,
          autoPlay: s,
          rightToLeft: u,
          prevNextButtons: !1,
          cellSelector: ".carousel__slide",
          imagesLoaded: true,
          resize: false,
          percentPosition: false,
          on: {},
        };
      heroBanner && (m.resize = !0);
      if (i.length < 1) return;
      if (e.classList.contains("image-with-text-slideshow__image")) {
        let g = e.parentNode.querySelector(
            ".image-with-text-slideshow__content"
          ),
          p = e.querySelectorAll(".image-with-text-slideshow__image-media");
        (m.draggable = !1),
          (m.asNavFor = g),
          p.length &&
            p[0].classList.contains("desktop-height-auto") &&
            (m.adaptiveHeight = !0);
      }
      if (e.classList.contains("customer-reviews__image")) {
        let f = e.parentNode.querySelector(".customer-reviews__content");
        (m.draggable = !1), (m.asNavFor = f);
      }
      (e.classList.contains("image-with-text-slideshow__content") ||
        e.classList.contains("testimonials__carousel") ||
        e.classList.contains("customer-reviews__content") ||
        e.classList.contains("customer-reviews__image")) &&
        (m.adaptiveHeight = !0),
        e.classList.contains("custom-dots") &&
          (y &&
            e.classList.contains("main-slideshow") &&
            this.prepareAnimations(e, c),
          (m.pauseAutoPlayOnHover = !1),
          (m.on = {
            staticClick: function () {
              this.unpausePlayer();
            },
            ready: function () {
              let i = this;
              if (
                (y &&
                  e.classList.contains("main-slideshow") &&
                  (e.animateSlides(0, c),
                  gsap.set(
                    e.querySelectorAll(".subheading,.split-text,.button"),
                    { visibility: "visible" }
                  )),
                t && n)
              ) {
                let s = n.querySelectorAll("li");
                s.forEach((e, t) => {
                  e.addEventListener("click", (e) => {
                    i.select(t);
                  });
                }),
                  s[this.selectedIndex].classList.add("is-selected");
              }
              heroBanner && i.resize();
              document.fonts.ready.then(function () {
                i.resize();
              });
              let a = i.cells[0].element.querySelector(
                ".slideshow__slide-video-bg"
              );
              a &&
                (a.querySelector("iframe")
                  ? (a.querySelector("iframe").onload = function () {
                      e.videoPlay(a);
                    })
                  : a.querySelector("video") &&
                    (a.querySelector("video").onloadstart = function () {
                      e.videoPlay(a);
                    }));
            },
            change: function (i) {
              let a = fizzyUIUtils.modulo(
                this.selectedIndex - 1,
                this.slides.length
              );
              if (
                (y &&
                  e.classList.contains("main-slideshow") &&
                  (setTimeout(() => {
                    e.animateReverse(a, c);
                  }, 300),
                  e.animateSlides(i, c)),
                t && n)
              ) {
                let l = n.querySelectorAll("li");
                l.forEach((e, t) => {
                  e.classList.remove("is-selected");
                }),
                  l[this.selectedIndex].classList.add("is-selected");
              }
              heroBanner && this.resize();
              s && (this.stopPlayer(), this.playPlayer());
              let o = $.cells[a].element.querySelector(
                ".slideshow__slide-video-bg"
              );
              o && e.videoPause(o);
              let r = $.cells[i].element.querySelector(
                ".slideshow__slide-video-bg"
              );
              r &&
                (r.querySelector("iframe")
                  ? r.querySelector("iframe").classList.contains("lazyload")
                    ? (r
                        .querySelector("iframe")
                        .addEventListener("lazybeforeunveil", e.videoPlay(r)),
                      lazySizes.loader.checkElems())
                    : e.videoPlay(r)
                  : r.querySelector("video") && e.videoPlay(r));
            },
          })),
        e.classList.contains("main-slideshow") &&
          (e.classList.contains("desktop-height-image") ||
            e.classList.contains("mobile-height-image")) &&
          (m.adaptiveHeight = !0),
        e.classList.contains("products") &&
          ((m.wrapAround = !1),
          (m.on.ready = function () {
            var t = this;
            r &&
              window.addEventListener("resize", function () {
                e.centerArrows(t, o, r);
              }),
              window.dispatchEvent(new Event("resize"));
          })),
        d &&
          ((m.wrapAround = !1),
          (m.on.scroll = function (e) {
            (e = Math.max(0, Math.min(1, e))), (d.style.width = 100 * e + "%");
          }));
      let $ = new Flickity(e, m);
      (h = $.selectedIndex),
        (e.dataset.initiated = !0),
        heroBanner &&
          window.addEventListener("resize", () => {
            $.resize();
          }),
        o &&
          (o.addEventListener("click", (e) => {
            $.previous();
          }),
          o.addEventListener("keyup", (e) => {
            $.previous();
          }),
          r.addEventListener("click", (e) => {
            $.next();
          }),
          r.addEventListener("keyup", (e) => {
            $.next();
          })),
        Shopify.designMode &&
          e.addEventListener("shopify:block:select", (e) => {
            let t = i.indexOf(e.target);
            $.select(t);
          });
    }
    videoPause(e) {
      setTimeout(() => {
        "hosted" === e.dataset.provider
          ? e.querySelector("video").pause()
          : "youtube" === e.dataset.provider
          ? e.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            )
          : "vimeo" === e.dataset.provider &&
            e
              .querySelector("iframe")
              .contentWindow.postMessage(
                JSON.stringify({ method: "pause" }),
                "*"
              );
      }, 10);
    }
    videoPlay(e) {
      setTimeout(() => {
        "hosted" === e.dataset.provider
          ? e.querySelector("video").play()
          : "youtube" === e.dataset.provider
          ? e.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "playVideo",
                args: "",
              }),
              "*"
            )
          : "vimeo" === e.dataset.provider &&
            e
              .querySelector("iframe")
              .contentWindow.postMessage(
                JSON.stringify({ method: "play" }),
                "*"
              );
      }, 10);
    }
    prepareAnimations(e, t) {
      e.dataset.animationsReady ||
        (new SplitText(e.querySelectorAll("h1, p:not(.subheading)"), {
          type: "lines, words",
          linesClass: "line-child",
        }),
        e.querySelectorAll(".slideshow__slide").forEach((i, s) => {
          let a = gsap.timeline({ paused: !0 }),
            l = 0;
          if (
            ((t[s] = a),
            "swipe" == e.dataset.transition &&
              a.to(
                i,
                {
                  duration: i.classList.contains("is-initial-selected")
                    ? 0.2
                    : 0.7,
                  clipPath: "polygon(100% 0, 0 0, 0 100%, 100% 100%)",
                },
                "start"
              ),
            a.to(
              i.querySelector(".slideshow__slide-bg"),
              { duration: 1.5, scale: 1 },
              "start"
            ),
            i.querySelector(".subheading") &&
              (a.to(
                i.querySelector(".subheading"),
                { duration: 0.5, autoAlpha: 1 },
                0
              ),
              (l += 0.5)),
            i.querySelector("h1"))
          ) {
            let o =
              0.5 +
              (i.querySelectorAll("h1 .line-child div").length - 1) * 0.05;
            a.from(
              i.querySelectorAll("h1 .line-child div"),
              { duration: o, yPercent: "100", stagger: 0.05 },
              0
            ),
              (l += o);
          }
          if (i.querySelector("p:not(.subheading)")) {
            let r =
              0.5 +
              (i.querySelectorAll("p:not(.subheading) .line-child div").length -
                1) *
                0.02;
            a.from(
              i.querySelectorAll("p:not(.subheading) .line-child div"),
              { duration: r, yPercent: "100", stagger: 0.02 },
              0
            ),
              (l += r);
          }
          i.querySelectorAll(".button") &&
            a.fromTo(
              i.querySelectorAll(".button"),
              { y: "100%" },
              { duration: 0.5, y: "0%", stagger: 0.1 },
              0.2 * l
            ),
            (i.dataset.timeline = a);
        }),
        (e.dataset.animationsReady = !0));
    }
    animateSlides(e, t) {
      document.fonts.ready.then(function () {
        t[e].timeScale(1).restart();
      });
    }
    animateReverse(e, t) {
      t[e].timeScale(3).reverse();
    }
    centerArrows(e, t, i) {
      let s = e.cells[0],
        a = 0,
        l = s.element.querySelector(".product-featured-image").clientHeight;
      if (
        (e.cells.forEach((e, t) => {
          e.size.height > a && (a = e.size.height);
        }),
        a > l)
      ) {
        let o = -((a - l) / 2);
        (t.style.transform = "translateY(" + o + "px)"),
          (i.style.transform = "translateY(" + o + "px)");
      }
    }
  }
  customElements.define("slide-show", e);
}
